import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useFolded2025Data } from '~components/business-owner/Folded2025/hooks/useFolded2025Data';
import { DotSpinner } from '~components/commons/spinners/DotSpinner';

import styles from './Folded2025Intro.module.scss';

import Folded2025Logo from '../../assets/Folded2025Logo.svg?react';
import BottomLeft from '../../assets/Intro_BottomLeft.svg?react';
import BottomRight from '../../assets/Intro_BottomRight.svg?react';
import CentsLogo from '../../assets/Intro_CentsLogo.svg?react';
import DecorativeStar from '../../assets/Intro_DecorativeStar.svg?react';
import TopLeft from '../../assets/Intro_TopLeft.svg?react';
import TopRight from '../../assets/Intro_TopRight.svg?react';

type Folded2025IntroProps = {
	startExperience: () => void;
};

const Folded2025Intro = (props: Folded2025IntroProps): JSX.Element => {
	const { isLoading } = useFolded2025Data();

	return (
		<div className={styles.container}>
			<TopLeft className={styles.topLeftDecoration} />
			<TopRight className={styles.topRightDecoration} />

			<BottomLeft className={styles.bottomLeftDecoration} />
			<BottomRight className={styles.bottomRightDecoration} />

			<CentsLogo className={styles.centsLogo} />
			<DecorativeStar className={styles.decorativeStar} />

			<Folded2025Logo className={styles.logo} />

			<button
				disabled={isLoading}
				onClick={props.startExperience}
				className={styles.ctaButton}
			>
				{isLoading ? <DotSpinner /> : 'See your 2025 recap'}
			</button>
		</div>
	);
};

export default Folded2025Intro;
